export const toYenString = (value: number) => {
  if (Math.abs(value) >= 100_000_000) {
    return `${Math.floor(value / 100_000_000).toLocaleString()}億円`
  }

  if (Math.abs(value) >= 10_000) {
    return `${Math.floor(value / 10_000).toLocaleString()}万円`
  }

  return `${value.toLocaleString()}円`
}

export const toYenStringWithFirstDecimal = (value: number) => {
  if (Math.abs(value) >= 100_000_000) {
    return `${(value / 100_000_000).toLocaleString(undefined, {
      maximumFractionDigits: 1,
    })}億円`
  }

  if (Math.abs(value) >= 10_000) {
    return `${(value / 10_000).toLocaleString(undefined, {
      maximumFractionDigits: 1,
    })}万円`
  }

  return `${value.toLocaleString()}円`
}
